'use strict';

var jsxRuntime = require('react/jsx-runtime');

const SmallList = ({ testId, className })=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_5639_547)",
                children: [
                    jsxRuntime.jsx("path", {
                        d: "M4.24097 2.76135H14.0001",
                        stroke: "currentColor",
                        strokeWidth: "1.4",
                        strokeLinejoin: "round"
                    }),
                    jsxRuntime.jsx("path", {
                        d: "M4.24097 7.00031H14.0001",
                        stroke: "currentColor",
                        strokeWidth: "1.4",
                        strokeLinejoin: "round"
                    }),
                    jsxRuntime.jsx("path", {
                        d: "M4.24097 11.2393H14.0001",
                        stroke: "currentColor",
                        strokeWidth: "1.4",
                        strokeLinejoin: "round"
                    }),
                    jsxRuntime.jsx("path", {
                        d: "M2.11569 2.76106C2.11569 2.87755 2.00638 3.02211 1.80784 3.02211C1.6093 3.02211 1.5 2.87755 1.5 2.76106C1.5 2.64456 1.6093 2.5 1.80784 2.5C2.00638 2.5 2.11569 2.64456 2.11569 2.76106Z",
                        fill: "currentColor",
                        stroke: "currentColor"
                    }),
                    jsxRuntime.jsx("path", {
                        d: "M2.11569 7.00001C2.11569 7.1165 2.00638 7.26107 1.80784 7.26107C1.6093 7.26107 1.5 7.1165 1.5 7.00001C1.5 6.88352 1.6093 6.73895 1.80784 6.73895C2.00638 6.73895 2.11569 6.88352 2.11569 7.00001Z",
                        fill: "currentColor",
                        stroke: "currentColor"
                    }),
                    jsxRuntime.jsx("path", {
                        d: "M2.11569 11.239C2.11569 11.3555 2.00638 11.5 1.80784 11.5C1.6093 11.5 1.5 11.3555 1.5 11.239C1.5 11.1225 1.6093 10.9779 1.80784 10.9779C2.00638 10.9779 2.11569 11.1225 2.11569 11.239Z",
                        fill: "currentColor",
                        stroke: "currentColor"
                    })
                ]
            }),
            jsxRuntime.jsx("defs", {
                children: jsxRuntime.jsx("clipPath", {
                    id: "clip0_5639_547",
                    children: jsxRuntime.jsx("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

module.exports = SmallList;
